import { EBAY, ETSY, FAIRE, SHOPIFY } from '../../constants/channels';
import { ATTRIBUTE } from '../../constants/attributes';
import { VALUE } from '../../constants/product';
import { FORM } from '../../constants/forms';

export function shouldShowForm({ product, type }) {
  const channel = product.get('channel');

  switch (channel) {
    case EBAY: {
      switch (type) {
        case FORM.DESCRIPTION:
        case FORM.DETAILS:
        case FORM.INVENTORY:
        case FORM.PHOTOS:
        case FORM.VIDEOS:
        case FORM.PRICING:
        case FORM.SHIPPING:
        case FORM.TITLE:
        case FORM.VARIATIONS: {
          return true;
        }

        default: {
          return false;
        }
      }
    }

    case ETSY: {
      switch (type) {
        case FORM.FILES: {
          return !!product.getIn([FORM.DETAILS, ATTRIBUTE.DIGITAL, VALUE]);
        }

        case FORM.SHIPPING:
        case FORM.VARIATIONS: {
          return !product.getIn([FORM.DETAILS, ATTRIBUTE.DIGITAL, VALUE]);
        }

        case FORM.DESCRIPTION:
        case FORM.DETAILS:
        case FORM.INVENTORY:
        case FORM.PERSONALIZATION:
        case FORM.PHOTOS:
        case FORM.VIDEOS:
        case FORM.PRICING:
        case FORM.TAGS:
        case FORM.TITLE: {
          return true;
        }

        default: {
          return false;
        }
      }
    }

    case FAIRE: {
      switch (type) {
        case FORM.DESCRIPTION:
        case FORM.DETAILS:
        case FORM.INVENTORY:
        case FORM.PHOTOS:
        case FORM.PRICING:
        case FORM.SHIPPING:
        case FORM.TITLE:
        case FORM.VARIATIONS: {
          return true;
        }

        default: {
          return false;
        }
      }
    }

    case SHOPIFY: {
      switch (type) {
        case FORM.DESCRIPTION:
        case FORM.DETAILS:
        case FORM.INVENTORY:
        case FORM.PHOTOS:
        case FORM.VIDEOS:
        case FORM.PRICING:
        case FORM.SEO:
        case FORM.SHIPPING:
        case FORM.TAGS:
        case FORM.TITLE:
        case FORM.VARIATIONS: {
          return true;
        }

        default: {
          return false;
        }
      }
    }

    default: {
      return false;
    }
  }
}
